import { Box } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';

import SlideMultiplexMarkers from 'components/StudyDashboard/ProceduresPage/ProcedureCard/SlideMultiplexMarkers';
import { getMergedCaseMultiplexSlide } from 'components/StudyDashboard/ProceduresPage/ProcedureCard/SlideMultiplexMarkers/multiplexChannelNaming';
import { UnwoundRow } from 'interfaces/genericFields/unwindRowsWithInnerArrays';
import { Procedure } from 'interfaces/procedure';
import { Slide } from 'interfaces/slide';
import { MULTIPLEX_STAIN_ID } from 'interfaces/stainType';

const renderMarkersCell = ({
  slide,
  studyId,
  caseId,
  slideId,
}: {
  slide?: Slide | null;
  studyId?: string;
  caseId?: string | number;
  slideId?: string;
}) => {
  if (!slide || slide?.stainingType !== MULTIPLEX_STAIN_ID) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', minWidth: 0, height: '100%' }}>
      <SlideMultiplexMarkers slide={slide} studyId={studyId} caseId={caseId} slideId={slideId} appearance="table" />
    </Box>
  );
};

export const renderSlideMarkersCell = (params: GridRenderCellParams<UnwoundRow<Procedure, Slide>>) => {
  return renderMarkersCell({
    slide: params.row as Slide,
    studyId: params.row.studyId,
    caseId: params.row._unwoundRowMetadata?.baseRowId,
    slideId: params.row._unwoundRowMetadata?.innerRowId as string | undefined,
  });
};

export const renderCaseMarkersCell = (params: GridRenderCellParams<Procedure>) => {
  return renderMarkersCell({
    slide: getMergedCaseMultiplexSlide(params.row.slides, params.row.id),
    studyId: params.row.studyId,
    caseId: params.row.id,
  });
};

export default renderSlideMarkersCell;
